const moment = require('moment');
const defaultState = {
    fc: [],
    fcDetail: {},
    loading: false,
    loadingHist: false,
    errors:{},
    lastFiltersFC:[],
    fcHist:[]
  }
  
export default (state=defaultState, action={}) => {
    switch (action.type) {

      case 'FETCH_FC_FULFILLED': {       
        let arrayMain=[];
        let newItem = {};

        if(Array.isArray(action.payload.data)){
            action.payload.data.forEach((element,index) => {
                newItem = {};
                newItem = element;//limpa para criar um novo. Criamos campos com hora convertida para mostrar em local time no  export de Excel
                newItem["BEGIN_DATETIME_LOCAL"] = moment.utc(element.BEGIN_DATETIME, 'YYYY-MM-DD HH:mm').tz(element.TIMEZONE).format('YYYY-MM-DD HH:mm');
                newItem["END_DATETIME_LOCAL"] = moment.utc(element.END_DATETIME, 'YYYY-MM-DD HH:mm').tz(element.TIMEZONE).format('YYYY-MM-DD HH:mm');
                arrayMain.push(newItem);
            });
        }else{
            console.log('FETCH_FC_FULFILLED error: ');
            console.dir(action.payload.data);
        }
        return {
          ...state,
          fc: arrayMain,
          loading: false,
          errors: {}
        }
      }
  
      case 'FETCH_FC_PENDING': {
        return {
          ...state,
          loading: true,
          errors: {}
        }
      }
  
      case 'FETCH_FC_REJECTED': {
        return {
          ...state,
          loading: false,
          errors: { global: action.payload.message }
        }
      }
  
      case 'FETCH_FC_DETAIL_FULFILLED': {
    
        const id = action.payload.data[0].ID;
        const status = action.payload.data[0].STATUS;
        
        return {
          ...state,
          fcDetail: action.payload.data[0],
          fc: state.fc.map(item => item.ID === id ? {...item, STATUS: status} : item),
          errors: {},
          loadingHist: false
        }
      }

      case 'FETCH_FC_DETAIL_PENDING': {
        return {
          ...state,
          loadingHist: true,
          fcDetail: {},
          errors: {}
        }
      }
      
      case 'FETCH_FC_DETAIL_REJECTED': {
        return {
          ...state,
          loadingHist: false,
          errors: { global: action.payload.message }
        }
      }      

      case 'LASTFILTER_FC': {      
        return {
          ...state,
          lastFiltersFC: action.payload
        }
      }

      case 'FETCH_FC_HISTORY_FULFILLED': {
        return {
          ...state,
          fcHist: action.payload.data,
          loadingHist: false,
          errors: {}
        }
      }
  
      case 'FETCH_FC_HISTORY_PENDING': {
        return {
          ...state,
          loadingHist: true,
          errors: {}
        }
      }
  
      case 'FETCH_FC_HISTORY_REJECTED': {
        return {
          ...state,
          loadingHist: false,
          errors: { global: action.payload.message }
        }
      }       

      case 'EDIT_FC_FULFILLED': {

        const id = action.editedRecord.ID;
        const auxEditedRecord = action.editedRecord;
        return {
            ...state,
            fc: state.fc.map(item => item.ID === id 
              ? auxEditedRecord 
              : item
              )
        }
      }

      default:
        return state;
    }
  }



// WEBPACK FOOTER //
// ./src/reducers/fc-reducer.js